export const PATH_REMOVE_ACCOUNT_REQUEST = '/remove-account/request';
export const PATH_REMOVE_ACCOUNT_CONFIRM = '/remove-account/:token';
